import { Component, ViewChild, EventEmitter, Output } from '@angular/core';
import { GettyOrderService } from 'src/app/admin/services/getty.order.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ToastrService } from 'ngx-toastr';
import { GettySelectListItemModel } from 'src/app/admin/models/getty.select.list.item.model';

@Component({
  selector: 'app-getty-order-search',
  templateUrl: './getty.order.search.component.html'
})
export class GettyOrderSearchComponent {
  @ViewChild('imageIdSelectionModal', { static: false }) imageIdSelectionModal: any;
  @Output() setImageId = new EventEmitter();
  modalReference: NgbModalRef;
  images = Array<GettySelectListItemModel>();
  imageId: number;
  index: number;
  fileName: string;
  photographerName: string;
  isModelLoaded: boolean = false;

  constructor(private modalService: NgbModal, private service: GettyOrderService,
    private ngxSpinner: NgxSpinnerService, private toastr: ToastrService) { }

  openImageSelectionModal(index: number) {
    this.reset();
    this.modalReference = this.modalService.open(this.imageIdSelectionModal);
    this.index = index;
  }

  search() {
    if (this.fileName.length > 0) {
      this.ngxSpinner.show();
      this.service.search(this.fileName).subscribe(res => {
        this.images = res;
        this.isModelLoaded = true;
        this.ngxSpinner.hide();
      }, error => {
        this.ngxSpinner.hide();
        AppUtils.processErrorResponse(this.toastr, error);
      });
    }
  }

  reset() {
    this.images = new Array<GettySelectListItemModel>();
    this.isModelLoaded = false;
    this.fileName = '';
  }

  onImageIdChange(id: number, photographerName: string) {
    this.imageId = id;
    this.photographerName = photographerName;
    this.setImageId.emit({ index: this.index, imageId: this.imageId, photographerName: this.photographerName });
    this.modalReference.close();
  }

  closeImageSelectionModal() {
    this.modalReference.close();
  }
}
